import { useContext, useEffect } from 'react'

import { dark } from 'design/index'

import { ThemeContext } from '../contexts/theme_context'

export const useThemeManager = () => {
  const [{ currentTheme }] = useContext(ThemeContext)

  useEffect(() => {
    const css = document.createElement('style')
    css.type = 'text/css'
    css.appendChild(
      document.createTextNode(
        `* {
       -webkit-transition: none !important;
       -moz-transition: none !important;
       -o-transition: none !important;
       -ms-transition: none !important;
       transition: none !important;
    }`,
      ),
    )
    document.head.appendChild(css)
    if (currentTheme === 'dark') {
      document.body.classList.add(dark)
    } else {
      document.body.classList.remove(dark)
    }
    setTimeout(() => {
      window.getComputedStyle(css).opacity
      document.head.removeChild(css)
    }, 1000)
  }, [currentTheme])
}
